import { render, staticRenderFns } from "./shop.sidebar.vue?vue&type=template&id=540476f7&"
import script from "./shop.sidebar.vue?vue&type=script&lang=js&"
export * from "./shop.sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports